import { useMutation } from '@apollo/client'
import { useState } from 'react'
import toast from 'react-hot-toast'

import Button, { ButtonIntents } from 'shared/ui/Button'
import Flex from 'shared/ui/Flex'
import Input from 'shared/ui/Input'
import IslandModal from 'shared/components/modals/IslandModal'
import { FIX_PAGES_WITH_WRONG_ID_META } from 'data/layoutcreator/mutations/admin'

type FixPagesWithWrongIdMetaModalProps = {
  isOpen: boolean
  closeModal: () => void
}

const FixPagesWithWrongIdMetaModal: React.FC<FixPagesWithWrongIdMetaModalProps> = ({
  isOpen,
  closeModal,
}) => {
  const [projectId, setProjectId] = useState('')
  const [chiliFolderName, setChiliFolderName] = useState('')

  const [fixPagesWithWrongIdMeta] = useMutation(FIX_PAGES_WITH_WRONG_ID_META)

  const handleSubmit = async () => {
    const toastId = toast.loading('Fixing pages with wrong IDs...')

    const { data, errors } = await fixPagesWithWrongIdMeta({
      variables: {
        projectId,
        chiliFolderName
      }
    })

    toast.dismiss(toastId)

    if (errors) {
      toast.error('Failed to fix pages with wrong IDs 😬')
      return
    } else if (data) {
      toast.success('Pages with wrong IDs fixed successfully 👌')
      closeModal()
    }
  }

  return (
    <IslandModal
      isOpen={isOpen}
      closeModal={closeModal}
      width={600}
      title="Fix pages with wrong IDs"
    >
      <Flex direction="column">
        <Flex direction="column" rowGap={16}>
          <Input value={projectId} onChange={setProjectId} label="Project ID" />
          <Input value={chiliFolderName} onChange={setChiliFolderName} label="Chili folder name" />
        </Flex>

        <Flex marginTop={46}>
          <Button
            intent={ButtonIntents.dark}
            labelId="Admin.buttons.submit"
            borderRadius={100}
            isFullWidth
            isDisabled={!projectId || !chiliFolderName}
            onClick={handleSubmit}
          />
        </Flex>
      </Flex>
    </IslandModal>
  )
}

export default FixPagesWithWrongIdMetaModal 